import { createReducer } from 'redux-act'
import u from 'updeep'

import { receive } from 'actions/cellars'

const initialState = {}

export default createReducer({
  [receive]: (state, { locale, id, cellar }) => {
    const locations = {}
    for (const location of cellar.locations) {
      locations[location._id] = {}
      locations[location._id][locale] = Object.assign({}, location, { cellar: id })
    }
    return u(locations, state)
  },
}, initialState)
